import { useQuery } from '@tanstack/react-query'
import { settlementGetSettlementAccountOptions, type SettlementAccount } from '@repo/sdk'

import { getStoredUser } from '../../lib/auth-storage'

interface UseGetSettlementAccountReturn {
  account: SettlementAccount | null
  isLoading: boolean
  isNotFound: boolean
  refetch: () => void
}

function getErrorStatus(error: unknown): number | undefined {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    return typeof error.status === 'number' ? error.status : undefined
  }
  return undefined
}

export function useGetSettlementAccount(): UseGetSettlementAccountReturn {
  const dealerId = getStoredUser()?.userId ?? ''

  const { data, isLoading, error, refetch } = useQuery({
    ...settlementGetSettlementAccountOptions({ path: { dealerId } }),
    enabled: !!dealerId,
    retry: (failureCount, err) => {
      if (getErrorStatus(err) === 404) return false
      return failureCount < 3
    },
  })

  const isNotFound = getErrorStatus(error) === 404

  return {
    account: data ?? null,
    isLoading,
    isNotFound,
    refetch: () => void refetch(),
  }
}
